import React, { useContext, useMemo } from "react";
import { NavDropdown } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { jsonKeyMapping, templateActionEnum } from "../../../Config/Constants";
import TemplateDataContext from "../../../Contexts/TemplateData.context";
import FormDataContext from "../../../Contexts/FormData.context";
import { TemplateObject } from "../../../Models/TemplateObject";
import {
  isStepCompleted,
  hasIncompleteFields,
} from "../../../Util/StepCompletionHelper";
type Props = {
  steps: TemplateObject[];
  uri: string;
  onAttemptNavigate?: (step: TemplateObject, defaultNavigate: () => boolean) => boolean | void; // returns true if intercepted
  shouldInterceptNavigation?: boolean;
};

const DropDownItems = ({ steps, uri, onAttemptNavigate, shouldInterceptNavigation }: Props) => {
  const { state, dispatch } = useContext(TemplateDataContext);
  const { activeTemplateSteps } = state;
  const { state: formState } = useContext(FormDataContext);
  const { formData } = formState;
  const navigate = useNavigate();

  const { stepName } = useParams();
  let isVisited = false;
  /* side navbar button handler */
  const handleClose = (step: TemplateObject) => {
    navigate(`${uri}/${step[jsonKeyMapping.SLUGIFY]}`);
    dispatch({ type: templateActionEnum.SET_NAVBAR_STATE, payload: false });
  };
  const attemptNavigate = (step: TemplateObject) => {
    const defaultNavigate = () => {
      handleClose(step);
      return false; // not intercepted
    };
    if (shouldInterceptNavigation && onAttemptNavigate) {
      const intercepted = onAttemptNavigate(step, defaultNavigate);
      if (intercepted) return; // do not navigate if intercepted
      handleClose(step);
      return;
    }
    handleClose(step);
  };
  return (
    <>
      {steps.map((step: TemplateObject, index: number) => {
        const isActive = stepName === step[jsonKeyMapping.SLUGIFY];
        /* Find the current step index */
        const stepIndex = activeTemplateSteps.findIndex(
          (step) => step[jsonKeyMapping.SLUGIFY] === stepName
        );
        /* compare the current step index with the steps   */
        for (let index = 0; index < activeTemplateSteps.length; index++) {
          if (
            activeTemplateSteps[index][jsonKeyMapping.SLUGIFY] ===
            step[jsonKeyMapping.SLUGIFY]
          ) {
            stepIndex > index ? (isVisited = true) : (isVisited = false);
          }
        }

        // Determine step completion status
        const stepCompleted = isStepCompleted(step, formData);
        const stepIncomplete = hasIncompleteFields(step, formData);

        const rawLabel: string = (step[jsonKeyMapping.NAV_TITLE] || step[jsonKeyMapping.SLUG] || '').toString();
        const slugBase = rawLabel
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9\s-]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
        const idAttr = `nav-item-${slugBase}`;
        return (
          <NavDropdown.Item
            className={`ms-2 p-2 nav-dropdown-item nav-item-flex ${
              isActive && "active fw-700"
            } ${isVisited && "grey-color fw-700"}`}
            key={index}
            onClick={() => attemptNavigate(step)}
          >
            {/* COMMENTED OUT - Circle removed from left navigation bar */}
            {/* <svg
                            width="15"
                            height="15"
                            viewBox="0 0 100 100"
                            className="me-3 dote"
                        >
                            <circle cx="50" cy="50" r="40" stroke="#000" strokeWidth="0" />
                        </svg> */}
            <div className="nav-item-text" id={idAttr} data-nav-slug={slugBase}>
              {rawLabel}
            </div>
            <div className="nav-spacer"></div>
            <div className="nav-icon">
              {stepCompleted && (
                <span className="status-icon completed">✓</span>
              )}
              {stepIncomplete && !stepCompleted && (
                <span className="status-icon incomplete">⚠</span>
              )}
            </div>
          </NavDropdown.Item>
        );
      })}
    </>
  );
};

export default DropDownItems;
